export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/math.js
// module id = 217
// module chunks = 0